import { Link } from '@tanstack/react-router'

import NewsIcon from '@/components/assets/News'
import useColorModeValue from '@/hooks/useColorModeValue'

const NewsReleases = () => {
    const iconsColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')
    return (
        <Link data-id="news-release-link" to={'/news'} style={{ marginRight: '8px' }}>
            <NewsIcon color={iconsColor} />
        </Link>
    )
}

export default NewsReleases
